<template>
  <el-table v-loading="loading" :data="data">
    <el-table-column label="STT" type="index" width="50"></el-table-column>
    <el-table-column label="Tên tiện ích" prop="name">
      <template slot-scope="scope">
        <span>{{ scope.row.name }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Nhóm tiện ích" prop="group" width="160">
      <template slot-scope="scope">
        <span>{{ getGroupName(scope.row.group) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Ngày khởi tạo" prop="created_at" width="160">
      <template slot-scope="scope">
        <span>{{ scope.row.created_at }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Ngày sửa" prop="updated_at" width="160">
      <template slot-scope="scope">
        <span>{{ scope.row.updated_at }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Ngôn ngữ" width="250" align="center">
      <template slot-scope="scope">
        <el-row type="flex" align="middle" justify="center" style="flex-wrap: wrap">
          <img
            v-for="locale in locales"
            :key="locale.code"
            class="language"
            :class="{ inactive: !scope.row.translations || !scope.row.translations.find((t) => t.locale === locale.code) }"
            :src="require(`@/assets/images/${locale.code}.png`)"
            alt="href"
          />
        </el-row>
      </template>
    </el-table-column>
    <el-table-column label="Thao tác" width="100" align="center" fixed="right">
      <template slot-scope="scope">
        <el-tooltip content="Chỉnh sửa" placement="top">
          <el-button icon="el-icon-edit" type="primary" circle size="small" @click="handleUpdatePlaceFacility(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip content="Xóa" placement="top">
          <el-button icon="el-icon-delete" type="danger" circle size="small" @click="handleDeletePlaceFacility(scope.row)"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { deletePlaceFacility } from '@/services/place/facility'

export default {
  name: 'ListPlaceFacilities',
  props: {
    data: Array,
    loading: Boolean
  },
  computed: {
    ...mapGetters(['constant']),
    locales() {
      return this.constant.constants.locales
    }
  },
  methods: {
    getGroupName(group) {
      if (!group) return ''
      if (typeof group === 'object' && group.name) return group.name
      const val = typeof group === 'object' ? (group.slug || group.id) : group
      const groups = (this.constant && this.constant.constants && this.constant.constants.place_facility_groups) || []
      const found = groups.find((g) => g.slug === val || g.id === val)
      return found ? found.name : val
    },
    handleDeletePlaceFacility(row) {
      this.$confirm('Bạn có chắc chắn muốn xóa tiện ích này không?', 'Cảnh báo', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        deletePlaceFacility(params).then(() => {
          this.$notify.success({
            title: 'Thành công',
            message: 'Xóa tiện ích thành công'
          })
          this.$emit('reload')
        })
      })
    },
    handleUpdatePlaceFacility(row) {
      this.$emit('update', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.facility-avatar {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: cover;
}
.text-muted {
  color: #909399;
}
img {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  margin: 5px 0;
  &.language {
    width: 28px;
    height: 28px;
    border-radius: 0px;
    margin: 0 5px;
    &.inactive {
      filter: grayscale(100%);
    }
  }
}
</style>
